 <template>
    <div :class="{'ly-is-full':isFull}" class="alarmsBg">

        <div class="devicemanage_class">
            <!-- <div class="tableSelect" style=" margin-bottom: 1px;pa" ref="tableSelect1" >&nbsp;&nbsp;设备总览</div> -->
            <!-- <div  style=" padding: 13px 0px 15px 30px;" ref="tableSelect1" >&nbsp;&nbsp;&nbsp;设备总览</div> -->
            <div  class="dev-table-title" ref="tableSelect1" >设备总览</div>
            
            <div class="rt-container" style="margin-bottom: 10px" ref="tableSelect2" >
                <div class="div_11">
                  <div class="dev_11_backgroud_1">
                 </div>
                 <div class="space-main">
                            <div class="space-main-up">
                                <span style="font-size: 24px;color: #e9c32a;">{{ deviceInfo.total }}</span>
                                <span style="font-size: 18px;">&nbsp;台</span>
                            </div> 
                            <div class="space-header">
                        <div class="space-header-title" >设备总数</div> 
                    </div>
                    </div>

                </div>
              

                <div class="div_22 dev_11_backgroud_1_1"></div>
                 <div class="div_11">
                    <div class="dev_11_backgroud_2"></div>
                    <div class="space-main">
                            <div class="space-main-up">
                                <span v-if = "userName=='nmyh'" style="font-size: 24px;color: rgb(39, 213, 120);">{{deviceInfo.health+deviceInfo.fault}}</span>
                                <span v-else style="font-size: 24px;color: rgb(39, 213, 120);">{{deviceInfo.health}}</span>
                                <span style="font-size: 18px;">&nbsp;台</span>
                            </div> 
                            <div class="space-header">
                        <div class="space-header-title" >正常运行设备数</div> 
                    </div>
                    </div>
                   

                 </div>
               

                <div class="div_22 dev_11_backgroud_1_1"></div>
                <div class="div_11">
                    <div class="dev_11_backgroud_3"></div>
                    <div class="space-main">
                            <div class="space-main-up">
                                <span v-if = "userName=='nmyh'" style="font-size: 24px;color: rgb(255, 66, 58);">0</span>
                                <span v-else style="font-size: 24px;color: rgb(255, 66, 58);">{{deviceInfo.fault}}</span>
                                <span style="font-size: 18px;">&nbsp;台</span>
                            </div> 
                            <div class="space-header">
                        <div class="space-header-title" >报警设备数</div> 
                    </div>
                    </div> 

                </div>
                

                <div class="div_22 dev_11_backgroud_1_1"></div>
                <div class="div_11">
                    <div class="dev_11_backgroud_4"></div>
                    <div class="space-main">
                            <div class="space-main-up">
                                <span style="font-size: 24px;color:  rgb(71, 111, 187);">{{deviceInfo.stopped}}</span>
                                <span style="font-size: 18px;">&nbsp;台</span>
                            </div> 
                            <div class="space-header">
                        <div class="space-header-title" >停机设备数</div> 
                    </div>
                    </div>        

                </div>
               
                <div class="div_22 dev_11_backgroud_1_1"></div>
                 <div class="div_11">
                      
                <div class="dev_11_backgroud_5"></div> 
                <div class="space-main">
                            <div class="space-main-up">
                                <span style="font-size: 24px;color:  rgb(163, 163, 163);">{{deviceInfo.offline}}</span>
                                <span style="font-size: 18px;">&nbsp;台</span>
                            </div> 
                            <div class="space-header">
                        <div class="space-header-title" >离线设备数</div> 
                    </div>
                    
                    </div>       


                 </div>
              
             
                <div class="div_22 dev_11_backgroud_1_1"></div>

                <div class="div_11 div_111">
                    <div class="center-container_dev">
                        <el-button @click="AndDevice" icon="Plus" class="custom-button_dev">新增设备</el-button>
                    </div>
                </div>        
            </div>

        </div>
        <div class="devicemanage_class_1">
            <div  class="dev-table-title2" ref="tableSelect11" >设备管理</div>
            <div style="display: flex;justify-content: space-between;align-items: stretch;padding: var(--my-css-var-bg-padding);" :style="{ height: divHeight + 'px' }" >
                <div class="devicemanage_tree">
                
                    <el-tree ref="tree" :data="treeData" 
                    :highlight-current="false" 
                    :default-expand-all="true" 
                    @node-click="handleNodeClick"
                    >
                    <template v-slot="{ node, data }">
                        <span class="custom-tree-node" :title="node.label">
                        {{ node.label }}
                        </span>
                    </template>
                
                </el-tree>
                </div>
                <div class="tableSelect devicemanage_table" >
                    <div ref="tableSelect3" class="select_head">
                        <el-form :inline="true" :model="formInline" label-position="left">
                            <el-form-item label="设备类型：">
                                <el-select v-model="formInline.group_type" placeholder="请选择" size="default" clearable  style="width:100px">
                                    <el-option
                                        v-for="item in groupTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="工段：" >
                                <el-input size="default" v-model.trim="formInline.workshop_section" maxlength="30" placeholder="工段" clearable  style="width:130px"></el-input>
                            </el-form-item>
                            <el-form-item label="设备名称：">
                                <el-input size="default" v-model.trim="formInline.deviceName" maxlength="30" placeholder="设备名称" clearable  style="width:130px;"></el-input>
                            </el-form-item>
                            <el-form-item label="设备状态：">
                                <el-select v-model="formInline.deviceState" placeholder="请选择" size="default" clearable  style="width:80px;">
                                    <el-option
                                        v-for="item in deviceStateList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-button  @click="search" type="primary" icon="Search" style="margin-left: 40px;">查询</el-button>
                            <el-button  @click="handleEdit('','reset')" icon="Refresh">重置</el-button> 
                            <!-- <el-button type="primary" @click="bulkImports" style="margin-left: 100px;"> 批量导入</el-button> -->
                        </el-form>                                      
                    </div>

                    <div>
                        <el-table  :height="'calc('+(tableHeight)+'px)'"  border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%;">
                            <el-table-column type="index" width="60" align="center" label="序号">
                                <template #default="scope">
                                    <span v-text="getIndex(scope.$index)"></span>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="150" prop="name" label="设备名称"  align="center"></el-table-column>
                            <el-table-column min-width="100" prop="transform_group_type" label="设备类型" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column min-width="160" prop="branch_factory" label="分厂" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column min-width="160" prop="workshop_section" label="工段" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column min-width="70" prop="point_num" label="测点数量" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column min-width="70" prop="transform_device_status" label="设备状态" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column min-width="80" prop="transform_online" label="传感器状态" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column min-width="200" prop="latest_online_time" label="最新在线时间" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column  v-if = "userName !='sadmin'"   label="操作"   fixed="right" width="120" align="center">
                                <template #default="scope">
                                    <!-- <span class="table-operate-btn" @click="handleEdit(scope.row,'detail')" >详情</span> -->
                                    <span      class="table-operate-btn" @click="handleEdit(scope.row,'delete')" >删除</span>
                                </template>
                            </el-table-column>
                        </el-table>  
                    </div>
                    <div>
                        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                    </div>
                </div>
            </div>

        </div>
        <addDevice ref="addDeviceFlag" @refreshData="refreshAllData"></addDevice>
    </div>
</template>

<script>
    import {apiDeviceNumberStatistics,apiDevice,apiSensorDelete,apiSensorWithExtra,apiDeviceDelete,apiDevicesStatusList} from '@/api/api'
    import Pagination from "@/components/Pagination";
    import {dateFormats,getTableHeight} from "@/utils/util";
    import addDevice from "./components/addDevice";

    import LyGrowcard from "../../components/analysis/growCard";
    
    import deviceTypeConfig from "@/config"
    
    import { getStorage } from '../../utils/util';
    
    export default {
        name: "deviceInfo",
        components:{
            Pagination,
            addDevice, 
            LyGrowcard
        },
        data() {
            return {
                isFull:false,
                treeHighLightFlag:true,
                tableHeight:500,
                divHeight:500,
                loadingPage:false,
                userName:null,
                showOtherSearch:false,//隐藏过长的搜索条件
                formInline:{
                    deviceName: null,
                    deviceState: null,
                    group_type: null,
                    workshop_section:null,
                },
                pageparm: {
                    page: 1,
                    page_size: 10,
                    total: 0
                },
                tableData:[],
                deviceInfo:{
                    total:null,
                    online:null,
                    offline:null,
                    stopped:null,
                    fault:null
                },
                treeData: [
                    {
                        label: '内蒙古宜化化工有限公司',
                        children: [
                            {label: deviceTypeConfig.DEVICE_TYPE_1,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_2,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_3,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_4,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_5,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_6,children: [] }
                        ]
                    }       
                ],
                groupTypeList:[
                    {id:0,name:'全部'},
                    {id:1,name: "重点设备"},
                    {id:2,name: "大型机组"},
                ],
                deviceStateList:[
                    {id:0,name:'全部'},
                    {id:1,name:'健康'},
                    {id:2,name:'故障'}, 
                    {id:3,name:'停机'},
                    {id:4,name:'离线'},                   
                ],

                fntableParm:{
                    page: 1,
                    page_size: 10,
                    workshop_section_exact : null,
                    group_type: null,
                    name_exact : null,
                    status : null     
                },
                //route
                route_para :{
                    deviceType : 0,
                    flag : false ,
                },
                
                deviceId:[],
            }
        },

        methods:{
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },

            handleEdit(row,flag) {
                let vm = this
                if(flag=='delete') {
                    vm.$confirm('您确定要删除选中的数据吗？' ,
                     '警告',{
                        closeOnClickModal:false,
                        type:'warning'
                    }).then(res=>{
                        
                        apiDeviceDelete({id:row.id}).then(res=>{
                            this.$message.success("删除设备成功")
                            vm.search()
                            vm.getTreeData()
                        }) .catch(res => {  
                            this.$message.warning(`删除设备失败 : ${res.message}`)
                        });

                    }).catch(()=>{

                    })
                }
                else if(flag=="reset"){
                    this.fntableParm = {
                        page:1,
                        page_size: 10,
                    }
                    this.pageparm={
                        page: 1,
                        page_size: 10,
                        total: 0
                    }
                    this.treeHighLightFlag = false
                    this.formInline.deviceName = null
                    this.formInline.deviceState = null
                    this.formInline.group_type = null
                    this.formInline.workshop_section = null
                    this.getData()
                }
            },

            callFather(parm) {
                this.fntableParm.page = parm.page
                this.fntableParm.page_size = parm.page_size
                this.getData()
            },

            search() {
                this.pageparm.page = 1
                this.fntableParm.page = this.pageparm.page
                this.fntableParm.page_size = this.pageparm.page_size
                // this.fntableParm.page = 1
                // this.fntableParm.page_size = 10

                this.fntableParm.name_exact = this.formInline.deviceName
                this.fntableParm.workshop_section_exact = this.formInline.workshop_section
                
                if(this.formInline.group_type == null || this.formInline.group_type ==0)
                    this.fntableParm.group_type = null
                else
                    this.fntableParm.group_type = this.formInline.group_type

                if(this.formInline.deviceState == null || this.formInline.deviceState ==0)
                    this.fntableParm.status = null
                else                 
                    this.fntableParm.status = this.formInline.deviceState

                this.treeHighLightFlag = false
                this.getData()
            },

           

            getTreeData() {
                apiDeviceNumberStatistics().then(res => {
                    if(res.data.code ==200) {
                        this.deviceInfo = res.data.data
                    }
                }).catch(error => {  
                    if(error.msg)
                        this.$message.warning(`获取设备状态的数量失败 : ${error.msg}`);  
                    else if(error.message)
                        this.$message.warning(`获取设备状态的数量失败 : ${error.message}`);  
                    else 
                        this.$message.warning(`获取设备状态的数量失败`); 
                });


                apiDevice().then(res=>{
                    console.log(res.data);
                    
                    if(res.data.code ==200) {

                        this.treeData = [{
                            label: '内蒙古宜化化工有限公司',
                            //children:[]
                            children: [
                                {label: deviceTypeConfig.DEVICE_TYPE_1,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_2,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_3,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_4,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_5,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_6,children: [] }
                            ]
                        }]

                        let factory = [
                            deviceTypeConfig.DEVICE_TYPE_1,
                            deviceTypeConfig.DEVICE_TYPE_2,
                            deviceTypeConfig.DEVICE_TYPE_3,
                            deviceTypeConfig.DEVICE_TYPE_4,
                            deviceTypeConfig.DEVICE_TYPE_5,
                            deviceTypeConfig.DEVICE_TYPE_6
                        ]
                        for(let i =0;i<res.data.data.total;i++){
                                let index =  factory.indexOf(res.data.data.items[i].branch_factory)
                                if(index == -1)
                                    continue;
                                let node = this.treeData[0].children[index]
                                let find_flag = 0
                                let j = 0;
                                for(j = 0; j < node.children.length ;j++){
                                    if(node.children[j].label == res.data.data.items[i].workshop_section){
                                        find_flag = 1
                                        break;
                                    }
                                }
                                if(find_flag == 1){
                                    this.treeData[0].children[index].children[j].children.push({
                                        label: res.data.data.items[i].name,
                                    });
                                }else{
                                    this.treeData[0].children[index].children.push({  
                                        label: res.data.data.items[i].workshop_section,  
                                        children: []  
                                    }); 
                                    this.treeData[0].children[index].children[this.treeData[0].children[index].children.length - 1].children.push({  
                                        label: res.data.data.items[i].name,  
                                    }); 
                                }
                            
                        }
                    }
                }) .catch(error => {  
                    if(error.msg)
                        this.$message.warning(`获取设备列表失败 : ${error.msg}`);  
                    else if(error.message)
                        this.$message.warning(`获取设备列表失败 : ${error.message}`);  
                    else 
                        this.$message.warning(`获取设备列表失败`); 
                });
            },

 
            dataChange(items){
                this.tableData.length = 0
                for(let i = 0;i<items.length;i++){
                    this.tableData[i] = items[i]
                    switch(items[i].group_type){
                        case 1:  this.tableData[i].transform_group_type= "重点设备";break;
                        case 2:  this.tableData[i].transform_group_type= "大型机组";break;
                        default: this.tableData[i].transform_group_type= "未知" ;break;
                    }
                    switch(items[i].status){
                        case 0:  this.tableData[i].transform_device_status="未决" ;break;
                        case 1:  this.tableData[i].transform_device_status="健康" ;break;
                        case 2:  this.tableData[i].transform_device_status="故障" ;break;
                        case 3:  this.tableData[i].transform_device_status="停机" ;break;
                        case 4:  this.tableData[i].transform_device_status="离线" ;break;
                        default: this.tableData[i].transform_device_status="未知" ;break;
                    }               
                    this.tableData[i].transform_online = items[i].status == 4 ? '离线':'在线' 
                }       
            },
            
            getData(){
                this.loadingPage = true
                this.tableData.length = 0;

                // apiSensorWithExtra(this.fntableParm).then(res => {
                //     this.loadingPage = false
                //     if(res.data.code ==200) {
                //         this.dataChange(res.data.data.items)
                //         this.pageparm.total = res.data.data.total;
                //         let { page, page_size } = res.config.params 
                //         this.pageparm.page = page    
                //         this.pageparm.page_size = page_size  
                //     }else{
                //         this.$message.error(res.data.msg)
                //     }
                //  }) .catch(res => {  
                //     this.loadingPage = false
                //     this.$message.warning(`获取传感器信息失败 : ${res.msg}`)
                // });  

                apiDevicesStatusList(this.fntableParm).then(res => {
                    this.loadingPage = false
                    if(res.data.code ==200) {
                        this.dataChange(res.data.data.items)
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
                 }) .catch(res => {  
                    this.loadingPage = false
                    this.$message.warning(`获取传感器信息失败 : ${res.msg}`)
                }); 
            },
    
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},

            getTheTableHeight(){
                var bg_padding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--my-css-var-bg-padding'));
                var offsetHeight_sum = this.$refs.tableSelect1.offsetHeight + this.$refs.tableSelect2.offsetHeight + this.$refs.tableSelect3.offsetHeight +this.$refs.tableSelect11.offsetHeight
                this.tableHeight =  getTableHeight(offsetHeight_sum) -30 - 2 * bg_padding

                var offsetHeight_sum1 = this.$refs.tableSelect1.offsetHeight + this.$refs.tableSelect2.offsetHeight + this.$refs.tableSelect11.offsetHeight
                this.divHeight =  getTableHeight(offsetHeight_sum1,false) -130 - 2 * bg_padding
            },
            // 新增设备
            AndDevice(){
                this.$refs.addDeviceFlag.addDeviceFn(null,'新增设备信息')
            },
            // 批量导入
            bulkImports(){
                console,log('批量导入')
            },
            checkTailNode(node,label){
                if('children' in node){
                    for(let index = 0;index < node.children.length;index++){
                        if(this.checkTailNode(node.children[index],label) == true)
                            return true
                    }
                }else{
                    if(node.label == label){
                        console.log(`find already : ${node.label} is key`)
                        return true
                    }
                }
                return false
            },

            handleNodeClick(node) {
                this.treeHighLightFlag = true
                if(!('children' in node)){
                    // this.checkTailNode(this.treeData[0],node.label)
                    this.pageparm.page = 1
                    this.pageparm.page_size = 10
                    this.pageparm.total = 0
                    this.fntableParm = {
                        name_exact : node.label,
                        page : this.pageparm.page,
                        page_size : this.pageparm.page_size,
                    }

                    this.formInline.deviceName = node.label
                    this.formInline.deviceState = null
                    this.formInline.group_type = null
                    this.formInline.workshop_section = null
                    
                    this.getData()  
                }
            },

            refreshAllData(){
                this.search()
                this.getTreeData()
            },

        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            if(this.$route.query.status){
                this.route_para.deviceState = this.$route.query.status
                this.route_para.flag = true
                this.formInline.deviceState = parseInt(this.$route.query.status)
            } else {
                this.route_para.flag = false
            } 
            this.userName = getStorage('userName')
            this.getTreeData()
            if(this.route_para.flag){
                this.fntableParm = {
                    page : this.pageparm.page,
                    page_size : this.pageparm.page_size,
                    status : this.route_para.deviceState,
                }
            }else{
                this.fntableParm = {
                    page : this.pageparm.page,
                    page_size : this.pageparm.page_size,
                }                
            } 
            this.getData()
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
           
        },
        unmounted() {
              // 页面销毁，去掉监听事件
            window.removeEventListener("resize", this.listenResize);
        },
        created() {
         
        },
    }
</script>

<style lang="scss" scoped>
     .alarmsBg{
    
      background: url("../../assets/bigscreen/block_bg.jpg") no-repeat;
    //   background: #000;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      padding: var(--my-css-var-bg-padding);
    }

    .rt-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    
    .div_11{
        height: 100px;
        width: 20%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .div_111{
        justify-content: center;
    }

    .div_22{
       
        height: 100px;
        width: 3px;
      
    }

    .dev_11_backgroud_1_1{
        background: url("../../assets/bigscreen/线条.png") no-repeat;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat; 
    }


    .dev_11_backgroud_1{
        height: 100%;
        width: 50%;
        background: url("../../assets/bigscreen/devman1.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_2{
        height: 100%;
        width: 50%;
        background: url("../../assets/bigscreen/devman2.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_3{
        height: 100%;
        width: 50%;
        background: url("../../assets/bigscreen/devman3.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_4{
        height: 100%;
        width: 50%;
        background: url("../../assets/bigscreen/devman4.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }
    .dev_11_backgroud_5{
        height: 100%;
        width: 50%;
        background: url("../../assets/bigscreen/devman5.png") no-repeat;
        background-size: 50% 60%;
        background-position: 50% 60%;
        background-repeat: no-repeat; 
    }

    .space-header{
        font-size: 17px;
        margin-top:4px ;
    }
    .space-header-title{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .space-main{
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
    .space-main-up{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 20%;
    }
    .center-container_dev {
        display: flex;
        align-items:  flex-start;
        justify-content: center;
        padding-top: 12%;
    }

    .custom-button_dev {  
        background-image: url(../../assets/bigscreen/addDevButton.png);  
        background-size: cover; /* 根据需要调整背景图片的大小 */  
        border: none; /* 取消边框 */ 
    }  

    .devicemanage_class{
      background: url("../../assets/bigscreen/devicemanage_backgroud1.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }

    // .devicemanage_class_1{
    //   background: url("../../assets/bigscreen/block_bg.png") no-repeat;
    //   background-size: 100% 100%;
    //   background-position: center;
    //   background-repeat: no-repeat;
    // }

    .devicemanage_tree{
        background: var(--l-searchtoolbar-bg);
        box-shadow: var(--el-box-shadow-light);
        border: 1px solid var(--el-border-color-lighter);
        flex-grow: 0;
        padding-right: 20px;  
        width: 15%;
        overflow-x: auto;
        margin-bottom: 7px;
        .el-tree {
            overflow-x: auto; /* 显示横向滚动条 */
           
            }
        .custom-tree-node{
            width: 100%;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 禁止自动换行 */
            text-overflow: ellipsis; /* 使溢出部分以省略号显示 */
            display: block; /* 确保样式生效 */ 
        }
       
    }
    .select_head{
        margin-bottom :10px
    }
    .devicemanage_table{
        flex-grow: 1;
        margin-left: 10px;
        // margin-bottom: 10px;
        // margin-right: 5px;
        overflow-x: auto;
        
       
    }

    .dev-table-title {
        position: relative;
        left: 2%; 
        font-size: 15px; 
        font-weight: bold; 
        color: #fff; 
        padding-top: 0.6%;
        padding-left: 1%;
    }

    .dev-table-title2 {
        position: relative;
        font-size: 15px; 
        font-weight: bold;
        color: #fff;
        padding-top: 12px;
        padding-bottom: 7px;
        height: 18px;
        padding-left: 3%;
        background: url("../../assets/bigscreen/device_head_bg.png"),url("../../assets/bigscreen/device_head_bg2.png") ;
        background-repeat: no-repeat, no-repeat;  
        background-position: center, 1% 50%;
        background-size: 100% 100%, auto;;
    }

//     :deep(.el-tree){
//         overflow-x: auto;
//         width: 100%;
//         background-color: #fff;   
       
//     }
//    :deep(.el-tree-node__label)  {

//         width: 100%;
//         overflow: hidden; /* 超出部分隐藏 */
//         white-space: nowrap; /* 禁止自动换行 */
//         text-overflow: ellipsis; /* 使溢出部分以省略号显示 */
//         display: block; /* 确保样式生效 */
//        }
</style>